<template>
  <div id="modemASCompleteList" class="common_type2">
    <div class="common_tit_wrap">
      <div class="common_page_tit">모뎀 A/S</div>
      <div class="common_page_desc">
        저압 모뎀 웹사이트
        <template v-if="userInfoDetail.userRole === 2 || userInfoDetail.userRole === 3">
          |
          <template v-if="userInfoDetail.affiliateCode != null">
            <template v-for="afc in afcList" v-if="afc.codeValue === userInfoDetail.affiliateCode">{{afc.codeName}}</template>
          </template>
          <template v-if="userInfoDetail.officeCode != null">
            <template v-for="ofc1 in ofc1List" v-if="ofc1.codeValue === userInfoDetail.officeCode.substring(0, 5)">{{ofc1.codeName}}</template>
          </template>
        </template>
      </div>
      <div class="common_progress_wrap">
        <div class="common_progress_start" @click="movePage('RequestList')">요청<span v-if="mySession.userRole === 2">({{countParams.as['1']}}건)</span></div>
        <div class="common_progress_middle" @click="movePage('AcceptedList')">접수<span v-if="mySession.userRole === 2">({{countParams.as['2']}}건)</span></div>
        <div class="common_progress_middle" @click="movePage('ProgressList')">처리중<span v-if="mySession.userRole === 2">({{countParams.as['3']}}건)</span></div>
        <div class="common_progress_end on">완료<span v-if="mySession.userRole === 2">({{countParams.as['4']}}건)</span></div>
      </div>
    </div>
    <div class="common_list_notice_wrap">
      <img class="common_list_notice_bg" src="../../assets/common/ic_warning.svg"/>
      <div class="common_list_notice_tit_wrap">
        <div class="common_list_notice_tit">안내</div>
        <div class="common_list_notice_desc">모뎀 A/S 메뉴 기능을 처음 이용하시는 분은 반드시 우측의 [매뉴얼 & 담당자]를 확인하시고 이용하여 주시기 바랍니다.</div>
      </div>
      <div class="common_list_notice_manual" @click="openManual('ModemASComplete')">매뉴얼 & 담당자</div>
    </div>
    <div class="common_list_wrap">
      <div class="common_list_top">
        <div class="common_list_top_select">
          <select v-model="selectSize" @change="search(1)">
<!--            <option value="10">10줄 표시</option>-->
<!--            <option value="20">20줄 표시</option>-->
            <option value="50">50줄 표시</option>
            <option value="100">100줄 표시</option>
            <option value="200">200줄 표시</option>
            <option value="500">500줄 표시</option>
          </select>
        </div>
        <template v-if="mySession.userRole === 2">
          <div class="btn_top btn_green_t" @click="toggleList">모뎀 요청보기({{isOffice ? '등록자' : '본부'}})</div>
        </template>
      </div>
      <div class="common_list_middle">
        <div class="common_list_head">
          <div><span><input type="checkbox" v-model="checkAll" @click.stop="onClickCheckAll"/></span></div>
          <div><span>본부</span></div>
          <div><span>사업구분</span></div>
          <div><span>구축구분</span></div>
          <div><span>이동전화번호</span></div>
          <div><span>요청사항</span></div>
          <div><span>접수완료일</span></div>
          <div><span>처리완료일</span></div>
          <div><span>처리현황</span></div>
          <div><span>현재상태</span></div>
          <div><span>요청자</span></div>
          <div><span>처리자</span></div>
          <div><span>처리사항</span></div>
        </div>
        <div class="common_list_body">
          <div class="common_list_no_data" v-if="list.length <= 0">
            <img src="../../assets/common/bg_list_no_data.png"/>
            <span>대상 모뎀이 없습니다.</span>
          </div>
          <div :key="'as_' + item.asPid" v-for="item in list">
            <div><span><input type="checkbox" v-model="item.check" :value="item.asPid" @click.stop="onClickCheckItem(item)"/></span></div>
            <div>
              <span v-if="item.officeCode != null">
                <template v-for="ofc1 in ofc1List" v-if="ofc1.codeValue === (item.officeCode.length === 5 ? item.officeCode : item.officeCode.substring(0, 5))">{{ofc1.codeName}}</template>
              </span>
              <span v-else>-</span>
            </div>
            <div>
              <span v-if="item.projectType != null">
                <template v-for="prt in prtList" v-if="prt.codeValue === item.projectType">{{prt.codeName}}</template>
              </span>
              <span v-else>-</span>
            </div>
            <div>
              <span v-if="item.structType != null">
                <template v-for="stt in sttList" v-if="stt.codeValue === item.structType">{{stt.codeName}}</template>
              </span>
              <span v-else>-</span>
            </div>
            <div><span class="link fc_primary_blue" @click="showPopup('모뎀정보 보기', 'ModemViewPopup', item)">{{item.mobileNum}}</span></div>
            <div><span class="btn_status fc_white bc_status_gray" @click="showPopup('모뎀 A/S 요청사항 등록 및 수정', 'ModemASRequestPopup', item)">보기</span></div>
            <div>
              <span v-if="item.accUpdDate != null">{{item.accUpdDate}}</span>
              <span v-else>-</span>
            </div>
            <div>
              <span v-if="item.stepUpdDate != null">{{item.stepUpdDate}}</span>
              <span v-else>-</span>
            </div>
            <div>
              <span v-if="item.progressType != null">
                <template v-for="prg in prgList" v-if="prg.codeValue === item.progressType">{{prg.codeName}}</template>
              </span>
              <span v-else>-</span>
            </div>
            <div>
              <template v-if="item.currentState != null">
                <template v-for="crs in crsList" v-if="crs.codeValue === item.currentState">
                  <span :key="'crs_' + crs.codePid" class="btn_status fc_white" :class="item.currentState === 'CRS01' ? 'bc_status_green' : 'bc_status_red'">{{crs.codeName}}</span>
                </template>
              </template>
              <span v-else>-</span>
            </div>
            <div><span class="link fc_primary_blue" @click="showPopup(`모뎀 A/S 요청자 정보(${item.mobileNum})`, 'MemberPopup', item, 'R')">{{item.userName}}</span></div>
            <div><span class="link fc_primary_blue" @click="showPopup(`모뎀 A/S 처리담당자 정보(${item.mobileNum})`, 'MemberPopup', item, 'P')">{{item.asUserName}}</span></div>
            <div><span class="btn_status fc_white bc_status_gray" @click="showPopup('모뎀 A/S 처리사항', 'ModemASProgressPopup', item)">보기</span></div>
          </div>
        </div>
      </div>
      <div class="common_bottom_wrap">
        <template v-if="mySession.userRole === 4">
          <div class="btn_bottom btn_green_t" @click="downloadExcel">엑셀 다운로드</div>
        </template>
        <template v-if="mySession.userRole === 2">
          <div class="btn_bottom btn_blue_t" @click="requestComplete">처리확인(선택)</div>
        </template>
        <div class="common_list_page_wrap center_page">
          <paginate
            v-model="pageParams.page"
            :pageCount="pageParams.totalPage"
            :clickHandler="search"
            :prevText="'<'"
            :nextText="'>'"
            :containerClass="'page_wrap'">
          </paginate>
        </div>
      </div>
    </div>
    <excel-exporter ref="excel" :filter="excelFilter" :type="'modemASComplete'" @downloading="excelDownloadStarted" @fail="excelDownloadFail"/>
    <modal name="viewPopup" classes="popup_modal" width="725px" height="auto" scrollable>
      <popup :popup-params="popupParams" @hidePopup="hidePopup"/>
    </modal>
    <modal name="loadingProgress" classes="loading_progress_wrap" width="300px" height="200px">
      <div>{{progressMsg}}</div>
    </modal>
  </div>
</template>

<script>
import VueDatepickerLocal from 'vue-datepicker-local'
import Popup from '../common/Popup.vue'
import ExcelExporter from '../excel/ExcelExporter.vue'
import common from '../../script/common'
import modemAS from '../../script/modemAS'
import {defaultLoadingOptions} from '../../script/defaultConfig'

export default {
  components: {VueDatepickerLocal, ExcelExporter, Popup},
  props: ['countParams'],
  data () {
    return {
      // Common
      mySession: {},
      ko: common.getDatepickerLocal(),
      userInfoDetail: JSON.parse(sessionStorage.getItem('userInfoDetail')),
      // Data
      afcList: [],
      ofcList: [],
      ofc1List: [],
      rwkList: [],
      prtList: [],
      sttList: [],
      prgList: [],
      crsList: [],
      canRequestFlagList: common.canRequestFlagList(),
      // Search
      isOffice: false,
      // List
      filter: {
        page: 1,
        size: parseInt(this.selectSize)
      },
      selectSize: '50',
      list: [],
      checkAll: false,
      selectedItemList: [],
      // Paging
      pageParams: {
        hasNext: false,
        totalElements: 0,
        totalPage: 1,
        page: 10,
        size: parseInt(this.selectSize)
      },
      // Popup
      popupParams: {
        title: '',
        component: '',
        data: {}
      },
      // Excel Download
      excelFilter: {
        page: 1,
        size: 100000
      },
      excelDownloading: false,
      // loading
      progressMsg: '',
      vueLoadingOverlay: null
    }
  },
  mounted () {
    common.getSession(response => {
      if (response.data.resultCode === 1 && response.data.result != null && response.data.result.userPid != null && response.data.result.userRole != null) {
        this.mySession = response.data.result
        this.$emit('getCount')
        let intervalCnt = 0
        let interval = setInterval(() => {
          if (common.checkValidateData('session', sessionStorage.getItem('afcList')) &&
            common.checkValidateData('session', sessionStorage.getItem('ofcList')) &&
            common.checkValidateData('session', sessionStorage.getItem('rwkList')) &&
            common.checkValidateData('session', sessionStorage.getItem('prtList')) &&
            common.checkValidateData('session', sessionStorage.getItem('sttList')) &&
            common.checkValidateData('session', sessionStorage.getItem('prgList')) &&
            common.checkValidateData('session', sessionStorage.getItem('crsList'))) {
            clearInterval(interval)
            this.afcList = JSON.parse(sessionStorage.getItem('afcList'))
            this.ofcList = JSON.parse(sessionStorage.getItem('ofcList'))
            this.ofc1List = this.getOfc1List()
            this.rwkList = JSON.parse(sessionStorage.getItem('rwkList'))
            this.prtList = JSON.parse(sessionStorage.getItem('prtList'))
            this.sttList = JSON.parse(sessionStorage.getItem('sttList'))
            this.prgList = JSON.parse(sessionStorage.getItem('prgList'))
            this.crsList = JSON.parse(sessionStorage.getItem('crsList'))
            if (this.$route.params != null && this.$route.params.searchParams != null) {
              this.searchParams = this.$route.params.searchParams
              this.search(1)
            } else {
              this.search(1)
            }
          } else if (intervalCnt > 10) {
            clearInterval(interval)
            common.amsAlert('retry', '필수 데이터를 불러오지 못했습니다.')
          } else {
            intervalCnt++
          }
        }, 200)
      } else {
        common.amsAlert('general', '로그아웃 되었습니다.\n다시 로그인해주세요.')
        this.$router.replace('/Login')
      }
    })
  },
  methods: {
    // Button Action
    movePage (path) {
      this.$router.push(path)
    },
    downloadExcel () {
      if (this.excelDownloading) {
        common.amsAlert('general', '이미 다운로드 처리중입니다.')
        return
      }
      if (confirm('엑셀 다운로드는 데이터 양에 따라 상당한 시간이 소요될 수 있으며 데이터 10만개당 하나의 파일로 다운로드 됩니다.\n또한 브라우저 보안정책에 따라 연속 다운로드 권한을 허용해야합니다.\n정말 다운로드 하시겠습니까?')) {
        this.progressMsg = '다운로드 준비중...'
        this.$modal.show('loadingProgress')
        this.vueLoadingOverlay = this.$loading.show(defaultLoadingOptions)
        this.$refs.excel.runExport()
        this.excelDownloading = true
      }
    },
    excelDownloadStarted () {
      this.$modal.hide('loadingProgress')
      this.vueLoadingOverlay.hide()
      this.excelDownloading = false
    },
    excelDownloadFail () {
      this.$modal.hide('loadingProgress')
      this.vueLoadingOverlay.hide()
      this.excelDownloading = false
    },
    // Common
    getOfc1List () {
      return this.ofcList.filter(item => { return item.codeLevel === 0 })
    },
    // List
    onClickCheckAll () {
      this.selectedItemList = []
      for (let i = 0; i < this.list.length; i++) {
        this.list[i].check = !this.checkAll
        if (!this.checkAll) {
          this.selectedItemList.push(this.list[i])
        }
      }
    },
    onClickCheckItem (selectedItem) {
      if (selectedItem.check) {
        this.selectedItemList = this.selectedItemList.filter(item => { return item.asPid !== selectedItem.asPid })
      } else {
        this.selectedItemList.push(selectedItem)
      }
      this.checkAll = this.selectedItemList.length === this.list.length
    },
    toggleList () {
      this.isOffice = !this.isOffice
      this.search(1)
    },
    search (page) {
      this.filter = {
        page: page,
        size: parseInt(this.selectSize),
        asStep: 4
      }
      if (this.mySession.userRole === 2) {
        delete this.filter['sameOffice']
        if (this.isOffice) {
          this.filter.sameOffice = true
        }
      } else if (this.mySession.userRole === 3 || this.mySession.userRole === 4) {
        this.filter.sameOffice = true
      }
      this.updateList()
    },
    updateList () {
      let vueLoadingOverlay = this.$loading.show(defaultLoadingOptions)
      modemAS.getModemAS(this.filter, response => {
        console.log('[모뎀 A/S] 완료 목록', response)
        vueLoadingOverlay.hide()
        if (response.data.resultCode === 1) {
          const data = response.data.result.body
          let list = data.list
          for (let i = 0; i < list.length; i++) {
            list[i].check = false
          }
          this.list = list
          this.pageParams = {
            hasNext: data.hasNext,
            totalElements: data.totalElements,
            totalPage: data.totalPage,
            page: this.filter.page,
            size: this.filter.size
          }
        } else {
          common.amsAlert('retry', '모뎀 목록을 불러오지 못했습니다.')
          this.list = []
          this.pageParams = {
            hasNext: false,
            totalElements: 0,
            totalPage: 1,
            page: 1,
            size: this.filter.size
          }
        }
        this.checkAll = false
        this.selectedItemList = []
      })
    },
    showPopup (title, component, data, type) {
      this.popupParams.title = title
      this.popupParams.component = component
      this.popupParams.data = {type: 'C', data: data, userType: type, from: 'AS'}
      this.$modal.show('viewPopup')
    },
    hidePopup (args) {
      this.$modal.hide('viewPopup')
      if (args != null && args.type != null) {
        if (args.type === 'L') {
          this.selectedItemList = []
          this.updateList()
        }
      }
    },
    requestComplete () {
      if ((this.mySession.subRole & 2) === 0) {
        common.amsAlert('general', '권한이 없습니다.')
        return
      }
      const result = common.checkUserRoleAndList(this.mySession, 2, this.selectedItemList, 'finConfirm', 'AS')
      if (!result.code) {
        return
      }
      let vueLoadingOverlay = this.$loading.show(defaultLoadingOptions)
      modemAS.modemAS('delete', {
        list: result.list
      }, response => {
        console.log('[모뎀 A/S] 처리확인', response)
        vueLoadingOverlay.hide()
        if (response.data.resultCode === 1) {
          common.amsAlert('general', '선택한 모뎀을 처리확인했습니다.')
          this.updateList()
        } else {
          common.amsAlert('retry', '모뎀을 처리확인하지 못했습니다.')
        }
      })
    },
    openManual (type) {
      common.openManualNewWindow(type)
    }
  }
}
</script>

<style scoped>
#modemASCompleteList .common_list_middle > .common_list_head > div,
#modemASCompleteList .common_list_middle > .common_list_body > div > div {
  flex-shrink: 1;
  width: 100%;
}

#modemASCompleteList .common_list_middle > .common_list_head > div:nth-child(1),
#modemASCompleteList .common_list_middle > .common_list_body > div > div:nth-child(1) {
  flex-shrink: 0;
  width: 13px;
}

#modemASCompleteList .common_list_middle > .common_list_head > div:nth-child(5),
#modemASCompleteList .common_list_middle > .common_list_body > div > div:nth-child(5) {
  flex-shrink: 0;
  width: 85px;
}

#modemASCompleteList .common_list_middle > .common_list_head > div:nth-child(7),
#modemASCompleteList .common_list_middle > .common_list_body > div > div:nth-child(7),
#modemASCompleteList .common_list_middle > .common_list_head > div:nth-child(8),
#modemASCompleteList .common_list_middle > .common_list_body > div > div:nth-child(8) {
  flex-shrink: 0;
  width: 65px;
}
</style>



// WEBPACK FOOTER //
// src/components/modemAS/ModemASCompleteList.vue